var _style, _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProfile = function SvgProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "profile_svg__Light",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".profile_svg__st0{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round}")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 8.2,
    r: 2.8,
    className: "profile_svg__st0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 15.5c0-1.9-1.6-3.5-3.5-3.5s-3.5 1.6-3.5 3.5v3h1.6l.4 5h3l.4-5h1.6z",
    className: "profile_svg__st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 23.5h-6c-.6 0-1-.4-1-1V8.8c0-.3.2-.6.4-.8L11.4.7c.3-.2.8-.2 1.1 0L23.1 8c.3.2.4.5.4.8v13.7c0 .6-.4 1-1 1h-6",
    className: "profile_svg__st0"
  })));
};
export default SvgProfile;